import { match } from 'ts-pattern'

import type {
  ServiceGetByIdResponse,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { RecapShapeKepQueryResult } from './dto'
import type { RecapShapeKep, RecapShapeKepMeta } from './types'

import { toRecords } from './dto'

const RECAP_SHAPE_KEP_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['recap_shape_kep', key] as const

interface GetRecapParams {
  region: 'national' | 'province' | 'city'
  province_code?: string
  city_code?: string
}

type RecapShapeKepApiResponse = ServiceGetByIdResponse<RecapShapeKep> & {
  meta?: RecapShapeKepMeta
}

const getRecap = (
  params: GetRecapParams
): ServiceQueryOptionType<RecapShapeKepQueryResult> => ({
  queryKey: RECAP_SHAPE_KEP_QUERY_KEY(params),
  queryFn: async () => {
    try {
      const path = match(params.region)
        .with('province', () => `/province/${params.province_code}`)
        .with(
          'city',
          () => `/province/${params.province_code}/city/${params.city_code}`
        )
        .otherwise(() => '')

      const res = await api.get<RecapShapeKepApiResponse>(
        `/report/extension-personnel-main/recap-kep-type${path}`
      )

      return toRecords(res.data)
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const recapShapeKep = {
  queryKey: RECAP_SHAPE_KEP_QUERY_KEY,
  getRecap
}
